var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var colors = require("../../colors/colors");
var cio_datamodel = require("cio-datamodel");

var GridInteraction = require("../../abstract/gridInteraction.js");

var SelectionGridInteractionModel = function (model, editorModel) {
    this.makeObservableTreeNode();
    this.addGridInteraction(model.elements, editorModel);
};
lib_core.mixin(SelectionGridInteractionModel, lib_core.ObservableTreeNode);
lib_core.mixin(SelectionGridInteractionModel, GridInteraction);
lib_core.JsonParser.registerClass(SelectionGridInteractionModel, "SelectionGridInteractionModel");

module.exports = SelectionGridInteractionModel;
